import {
  createLightTheme,
  type BrandVariants,
  type Theme
} from "@fluentui/react-components";

// intnt brand palette, pulled from intntads.com (2026-06-15):
//   accent / primary   #0b00ff  (electric blue)
//   dark text/headings #1d212e → #373b48 (slate charcoal)
//   secondary text     #52586b
//   font               Inter
// These also live as CSS custom properties in web/public/brand/colors.css
// for any non-Fluent styling.
export const intntBrand = {
  accent: "#0b00ff",
  ink: "#1d212e",
  inkSoft: "#373b48",
  textSecondary: "#52586b"
} as const;

// 16-step brand ramp for Fluent's theme generator. Anchored so slot 80 ==
// the intnt accent (#0b00ff) — slot 80 is what light theme maps to
// colorBrandBackground / link colors; 70 and 60 are the hover/pressed
// (darker) states. Built monochromatically from the accent.
const brandRamp: BrandVariants = {
  10: "#04003d",
  20: "#0a0061",
  30: "#0d0085",
  40: "#1000a8",
  50: "#1200cc",
  60: "#0e00e6",
  70: "#0b00f2",
  80: "#0b00ff", // primary — the intnt accent
  90: "#3326ff",
  100: "#5546ff",
  110: "#7468ff",
  120: "#928aff",
  130: "#b0aaff",
  140: "#cdc9ff",
  150: "#e6e3ff",
  160: "#f4f2ff"
};

const base = createLightTheme(brandRamp);

// Inter as the app-wide type family (loaded via index.html), keeping
// Fluent's system-font stack as the fallback chain.
const interStack = `Inter, ${base.fontFamilyBase}`;

export const intntTheme: Theme = {
  ...base,
  fontFamilyBase: interStack
};
